// We use axios directly for public API calls.
import axios from 'axios';
import { fetchWithAuth } from '../redux/auth/authService';
import { STORAGE_KEYS } from '../redux/auth/authConstants';

// Get base URL from environment or fallback
const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

// Get appId from localStorage for public form submissions
const getAppId = () => parseInt(localStorage.getItem(STORAGE_KEYS.APP_ID) || '0', 10);

export const feedbackService = {
  submitFeedback: async (feedbackData) => {
    try {
      // Ensure AppId is always included so feedback is linked to the correct gym
      if (feedbackData instanceof FormData) {
        if (!feedbackData.has('AppId') || !feedbackData.get('AppId')) {
          feedbackData.set('AppId', getAppId());
        }
      }
      const response = await axios.post(`${API_URL}/api/Feedback/submit`, feedbackData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },

  getFeedbackList: async () => {
    try {
      // AppId is read from JWT claims on the backend — no need to pass it here
      const response = await fetchWithAuth('/api/Feedback/list', {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error fetching feedback list:', error);
      throw error;
    }
  },

  getFeedbackById: async (id) => {
    try {
      const response = await fetchWithAuth(`/api/Feedback/detail/${id}`, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error(`Error fetching feedback detail for ID ${id}:`, error);
      throw error;
    }
  }
};
